// ABOUTME: Context of the jobs launched from this tab: register a job to have its completion announced,
// ABOUTME: optionally with an action button on the completion snackbar, and read the finished ones.

import { createContext } from 'react';

/** A button on the completion snackbar of a job, e.g. "Open preview". */
export type JobOutcomeAction = {
    label: string;
    onClick: () => void;
};

export type AddJobOptions = {
    /** Shown on the completion snackbar of this tab (not on the other tabs of the browser). */
    outcomeAction?: JobOutcomeAction;
};

type JobSubscriptionContextType = {
    addJobId: (id: string, options?: AddJobOptions) => void;
    finishedJobIds: Set<string>;
    clearFinishedJob: (id: string) => void;
};

const JobSubscriptionContext = createContext<JobSubscriptionContextType | null>(null);

export default JobSubscriptionContext;
